<template lang="pug">
div.field.is-fullwidth
  .control
    .select.is-fullwidth
      select(v-model="selected")
        option(v-for="c of crews", :value="c") 
          span(v-if='c.code') {{c.code}}: 
          span {{c.name}}

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CrewPicker",

  computed: {
    ...mapState(["crew", "crews"]),
    selected: {
      get() {
        return this.$store.state.crew;
      },
      set(value) {
        this.$store.commit("crew", value);
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
</style>